import React, { useState, useEffect } from "react";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { Form, useFormik, FormikProvider } from "formik";
import axios from "axios";
import Cookies from "js-cookie";
import { BsArrowLeftShort } from "react-icons/bs";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import formModel from "./validationSchemas/formModel";
import { validateTaxAndCurrencyFormSchema } from "./validationSchemas/ShopifyValidateFormSchema";
import { Skeleton } from "@material-ui/lab";
import { TfiSave } from "react-icons/tfi";
import { toast } from "react-toastify";
import TaxForm from "./components/TaxForm";
import { useHistory } from "react-router-dom";

const { formId, formField } = formModel;

const useStyles = makeStyles((theme) => ({
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
}));

function ShopifyAppTaxSetting({ userinfo, language, feedsetting }) {
    const classes = useStyles();
    const history = useHistory();

    const [taxinclusive, SetTaxInclusiveValidation] = useState(false);
    const currentValidationSchema = validateTaxAndCurrencyFormSchema(
        taxinclusive
    );

    useEffect(() => {
        if (feedsetting && feedsetting.api_taxvalue) {
            SetTaxInclusiveValidation(true);
        }
    }, [feedsetting]);

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        let FinalData = {
            user_id: userinfo.id,
            data: [],
        };

        if (values.muti_currency) {
            FinalData.data.push({ api_currency: values.muti_currency });
        }
        if (values.noprice) {
            FinalData.data.push({ ifm_no_price: values.noprice ? 1 : 0 });
        }

        FinalData.data.push({
            api_taxvalue: values.taxinclusive ? values.tax_value : 0,
        });

        FinalData.data.push({
            api_taxname: values.taxinclusive ? values.tax_name : "",
        });

        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/update-iframe`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: FinalData,
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        "Your IFrame Currency and Tax Setting Updated Successfully.."
                    );
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            }).finally(() => {
                actions.setSubmitting(false);
            });
    }

    const [initialFormObj, setInitialFormObj] = useState({
        muti_currency: feedsetting?.api_currency || "",
        tax_name: feedsetting?.api_taxname || "",
        tax_value: feedsetting?.api_taxvalue || 0,
        noprice: feedsetting?.ifm_no_price || false,
        taxinclusive:
            feedsetting?.api_taxvalue > 0 &&
            feedsetting?.api_taxname.length > 0,
    });

    useEffect(() => {
        if (feedsetting) {
            setInitialFormObj({
                muti_currency: feedsetting?.api_currency || "",
                tax_name: feedsetting?.api_taxname || "",
                tax_value: feedsetting?.api_taxvalue || 0,
                noprice: feedsetting?.ifm_no_price || false,
                taxinclusive:
                    feedsetting?.api_taxvalue > 0 &&
                    feedsetting?.api_taxname.length > 0,
            });
        }
    }, [feedsetting]);

    const formik = useFormik({
        initialValues: initialFormObj,
        enableReinitialize: true,
        validationSchema: currentValidationSchema,
        onSubmit: _handleSubmit,
    });

    if (!Object.keys(formik.values).length) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>Shopify App CURRENCY & TAX SETTING</span>
                        <span className="small text-capitalize">
                            Configure pricing display, currency options, and tax
                            rules for your Shopify App.
                        </span>
                    </div>
                    <div>
                        <Button
                            disabled={formik.isSubmitting}
                            variant="contained"
                            color="primary"
                            className={classes.saveBtn}
                            onClick={formik.submitForm}
                        >
                            <TfiSave className="mr-3" size={13} />
                            {language.SETTING_PASSWORD_SAVE}
                            {formik.isSubmitting && (
                                <CircularProgress
                                    size={16}
                                    className={"ml-3"}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <FormikProvider value={formik}>
                    <Form id={formId}>
                        <TaxForm
                            formField={formField}
                            values={formik.values}
                            setFieldValue={formik.setFieldValue}
                            language={language}
                            feedsetting={feedsetting}
                        />
                    </Form>
                </FormikProvider>
            </div>
        </div>
    );
}

export default ShopifyAppTaxSetting;
